import {isNullOrUndefined} from "../../../../services/Validator";

export default function FlashResultsTabletContentLayout({children}) {
    // Used in FlashResultsScreen to frame content in tablet mode

    // BUILD
    if (isNullOrUndefined(children))
        return null;
    return (
        <div className={'w-[584px] h-[640px] min-h-[640px] hidden lg:hidden sm:flex sm:flex-col items-start justify-center pb-24'}>
            {children}
        </div>
    );
}